let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dcw3x")).then(() => parcelRequire('EHYXh'));